import { getSourcingSharedDefaultOutreachTemplatedWithEndingMessageController } from './getSourcingSharedDefaultOutreachTemplatedWithEndingMessageController';
import { CampaignType, Channels } from 'generated-graphql/types';

type GetEditedOpenMessageToUpdateProps = {
  campaignType: CampaignType;
  defaultStartingTemplatedMessage: string | null;
  editedOpeningMessage: string | null;
  customTemplatedMessage: string;
  channelType: Channels;
};

export const getEditedOpenMessageToUpdate = ({
  campaignType,
  defaultStartingTemplatedMessage,
  editedOpeningMessage,
  customTemplatedMessage,
  channelType
}: GetEditedOpenMessageToUpdateProps): string | undefined => {
  const generatedDefaultMessageWithEndingMessage =
    getSourcingSharedDefaultOutreachTemplatedWithEndingMessageController({
      campaignType,
      startingMessage: defaultStartingTemplatedMessage || '',
      channelType
    });

  const baselineMessage =
    editedOpeningMessage || generatedDefaultMessageWithEndingMessage;

  const isDefaultMessage = customTemplatedMessage === baselineMessage;

  return isDefaultMessage
    ? editedOpeningMessage ?? undefined
    : customTemplatedMessage;
};
